//@flow
import React from "react";
import "./breadcrumbs.scss";

export function Breadcrumbs() {
  return (
    <ul className="breadcrumbs">
      <li>
        <a href="/" className="breadcrumbs__link">
          Home
        </a>
      </li>
      <li>
        <a href="/search" className="breadcrumbs__link">
          Products
        </a>
      </li>
      <li>
        <a href="/wishlist" className="breadcrumbs__link">
          My Wishlist
        </a>
      </li>
    </ul>
  );
}
